import React from 'react';
import { observer } from 'mobx-react';
import { Theme, ThemedStyles, useStyles } from 'ui/base/theme';
import baseStyles from './radio_input.module.css';
import {
  RadioInput as BaseRadioInput,
  RadioInputProps as BaseRadioInputProps,
} from 'ui/base/input';

type RadioInputStyles = {
  unselected: string;
  selected: string;
  radio: string;
};

const themedStyles: ThemedStyles<RadioInputStyles> = {
  [Theme.DAYLIGHT]: {
    unselected: baseStyles.daylightUnselectedLabel,
    selected: baseStyles.daylightSelectedLabel,
    radio: baseStyles.radio,
  },
  [Theme.MIDNIGHT]: {
    unselected: baseStyles.midnightUnselectedLabel,
    selected: baseStyles.midnightSelectedLabel,
    radio: baseStyles.radio,
  },
};

export type RadioInputProps<T> = Omit<BaseRadioInputProps<T>, 'className'>;
export const RadioInput = observer(<T, >({ choice, store, ...props }: RadioInputProps<T>) => {
  const styles = useStyles(themedStyles);
  const selected = choice === store.selected;
  return (
    <label className={selected ? styles.selected : styles.unselected}>
      <BaseRadioInput<T> choice={choice} className={styles.radio} store={store} {...props}/>
    </label>
  );
});
